export namespace constants {

  export namespace env {

    export const NO_SERVER  = 'NO_SERVER';
    export const PORT       = 'PORT';
  }
}
